import React, { useState, useEffect } from "react";
import { getData, updateData } from "../../actions";
import {
  Grid,
  Button,
  Grow,
  TextField,
  Typography,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
} from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import Filter from "../../filter/filter";

export default function UserContainer(props) {
  const [email, setEmail] = useState("");
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [roles, setRoles] = useState("");
  const [departments, setDepartments] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [propertyName, setPropertyName] = useState("centerName");
  const [isLoading, setIsLoading] = useState(false);
  const [savedLoading, setSavedLoading] = useState(false);

  const [state, setState] = React.useState({
    checkedA: true,
  });

  const handleSwitch = (event) => {
    if (event.target.checked) {
      setPropertyName("centerName");
    } else {
      setPropertyName("centerCode");
    }
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  useEffect(() => {
    if (props.id) {
      userInfo();
      getDepartments();
    }
  }, []);
  const userInfo = async () => {
    try {
      setIsLoading(true);
      const { data } = await getData(`/userInfo/${props.id}`);
      const userDepartments = [];
      for (const obj of data.departments) {
        userDepartments.push({
          centerCode: obj.centerCode,
          centerName: obj.centerName,
        });
      }
      setEmail(data.email);
      setFirstname(data.firstName);
      setLastname(data.lastName);
      setRoles(data.roles[0]);
      setDepartments(userDepartments);
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
      props.handleClose("Cancel");
      alert("Oops something went wrong");
    }
  };
  const getDepartments = async () => {
    try {
      const { data } = await getData("/departments/spreadsheet/list");
      if (data.length > 0) {
        setDepartmentList(data);
      }
    } catch (e) {
      alert("Oops something went wrong");
    }
  };
  const saveData = async () => {
    setSavedLoading(true);
    try {
      const approvedDepartments = [];
      for (const obj of departments) {
        approvedDepartments.push({
          centerCode: obj.centerCode,
          centerName: obj.centerName,
          isApproved: true,
        });
      }
      const obj = {
        email,
        firstName: firstname,
        lastName: lastname,
        roles: [roles],
        departments: approvedDepartments,
      };
      const { data } = await updateData(`/userInfo/${props.id}`, { data: obj });
      if (data.nModified === 1) {
        setSavedLoading(false);
        props.handleClose([
          `${firstname} ${lastname}`,
          email,
          roles,
          departments,
        ]);
      } else {
        setSavedLoading(false);
        alert("No changes detected");
      }
    } catch (e) {
      alert("Oops something went wrong");
        
      setSavedLoading(false);
    }
  };
  return isLoading ? (
    <CircularProgress style={{ marginLeft: "45%" }} />
  ) : (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          <TextField
            variant="standard"
            label="Email"
            size="small"
            fullWidth
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            variant="standard"
            label="Firstname"
            size="small"
            fullWidth
            value={firstname}
            onChange={(e) => setFirstname(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            variant="standard"
            label="Lastname"
            size="small"
            fullWidth
            value={lastname}
            onChange={(e) => setLastname(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <FormControl style={{ width: "100%" }}>
            <InputLabel>Role</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              fullWidth
              value={roles}
              onChange={(e) => setRoles(e.target.value)}
            >
              <MenuItem value="Requestor">Requestor</MenuItem>
              <MenuItem value="Department Head">Department Head</MenuItem>
              <MenuItem value="Accounting Staff">Accounting Staff</MenuItem>
              <MenuItem value="Accounting Supervisor">
                Accounting Supervisor
              </MenuItem>
              <MenuItem value="Accounting Manager">Accounting Manager</MenuItem>
              <MenuItem value="Treasury">Treasury</MenuItem>
              <MenuItem value="President">President</MenuItem>
              <MenuItem value="CEA">CEA</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={12}>
          {isLoading ? (
            <></>
          ) : (
            <>
              <Filter
                listData={departmentList}
                filterValue={departments}
                label="Departments"
                propertyName={propertyName}
                onChange={(value) => setDepartments(value)}
              />

              <FormControlLabel
                control={
                  <Switch
                    checked={state.checkedA}
                    onChange={handleSwitch}
                    name="checkedA"
                    color="primary"
                  />
                }
                label={
                  propertyName === "centerCode" ? "Center Code" : "Center Name"
                }
              />
            </>
          )}
        </Grid>
        <Grid item xs={12} sm={12}>
          {savedLoading ? (
            <CircularProgress size={20} style={{ marginLeft: "46%" }} />
          ) : (
            <div style={{ float: "right" }}>
              <Button
                type="button"
                size="small"
                color="primary"
                onClick={() => saveData()}
              >
                Save
              </Button>
              <Button
                type="button"
                size="small"
                color="secondary"
                onClick={() => props.handleClose("Cancel")}
              >
                Cancel
              </Button>
            </div>
          )}
        </Grid>
      </Grid>
    </div>
  );
}
